import React from 'react';
import InfluenceCrmSideBar from './InfluenceCrmSideBar/InfluenceCrmSideBar';
import InfluenceCrmSubNav from './InfluenceCrmSubNav/InfluenceCrmSubNav';
import { initialCrmEmailState, store } from 'components/Store';
import { useContext } from 'react';
import { useEffect, useLayoutEffect } from 'react';
import useGetContactsTags from 'components/Dashboard/Filters/useGetContactsTags';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from 'components/Login/Loading';
import { Outlet, Route, Routes, useLocation, useNavigate, useParams } from 'react-router';
import WritingMyContent from 'components/WritingAssistant/WritingMyContent';
import AddTagsModal from './CrmContacts/AddTagsModal/AddTagsModal';
import InfluenceNotIncludedFeaturesPopup from './CrmContacts/InfluenceNotIncludedFeaturesPopup';
import { GroupSideBar } from './CrmGroups/GroupView';
import useEmailDomainsInitialCall from './useEmailDomainsInitialCall';
import { EmailStateProvider } from 'components/EmailStateProvider';
import { InteractionsListProvider } from './CrmInteractions/InteractionsListContext';

function InfluenceCrm() {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const { hideInfluenceSidebar, activePlan, crmContactsQtty, crmEmailsTableOnSort, showAddTagsModalCrmContacts } =
    state;
  const { totalCrmContacts, enableCrm } = activePlan;

  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const { groupId } = params;
  const query = new URLSearchParams(location.search);
  const sort = query.get('sort') ? query.get('sort').split('_') : null;

  useEmailDomainsInitialCall();
  useGetContactsTags();

  useEffect(() => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'contactsOversubscribed',
      value: totalCrmContacts - crmContactsQtty,
    });
  }, [crmContactsQtty, totalCrmContacts]);

  useLayoutEffect(() => {
    if (location.pathname === '/people/emails' && !sort && !crmEmailsTableOnSort?.sort?.length) {
      const nextQuery = new URLSearchParams(location.search);
      nextQuery.set('sort', 'lastUpdated_descending');
      navigate(
        {
          pathname: location.pathname,
          search: nextQuery.toString(),
          hash: location.hash,
        },
        { replace: true, state: location.state }
      );
    }
  }, [location.pathname]);

  const updateContactLocation = location.pathname.includes('/people/directory/update/');
  const hideSubnav = updateContactLocation;
  const hideSidebar = updateContactLocation || groupId;
  const hideSectionTitle = updateContactLocation || groupId;
  const groupIdCondition = groupId && groupId !== 'add';
  const shouldEnableEmailState =
    location.pathname.includes('/people/emails') ||
    location.pathname.includes('/people/email-performance') ||
    location.pathname.includes('/brief-policymakers/engagement-statistics');

  const content = (
    <InteractionsListProvider>
      {!hideSubnav && <InfluenceCrmSubNav />}
      <div
        className={`row mx-auto main-content-wrapper pb-lg-0 flex-grow-1 ${
          !hideSectionTitle ? 'content-lists-container' : ''
        }`}
      >
        <div
          className={`side-left-element d-none ${
            hideInfluenceSidebar || location.pathname.includes('/policymakers') ? '' : 'd-lg-block'
          } ${groupIdCondition ? 'side-left-group-page' : ''}`}
        >
          {!hideSidebar && (
            <div className='pl-lg-4'>
              <InfluenceCrmSideBar />
            </div>
          )}
          {groupIdCondition && <GroupSideBar />}
        </div>
        <Outlet />
        <Routes>
          <Route element={<NoMatchPage />} />
        </Routes>
        <AddTagsModal />
        <InfluenceNotIncludedFeaturesPopup
          type={'contacts'}
          setShowPopup={() => {
            dispatch({
              type: 'MODIFY_SECTION',
              parameter: 'showAddTagsModalCrmContacts',
              value: { show: false, preselectedContact: undefined },
            });
          }}
          showPopup={showAddTagsModalCrmContacts.show && !enableCrm}
        />
      </div>
    </InteractionsListProvider>
  );

  return shouldEnableEmailState ? (
    <EmailStateProvider initialCrmEmailState={initialCrmEmailState}>{content}</EmailStateProvider>
  ) : (
    content
  );
}

const InfluenceWritingAssistant = () => {
  return (
    <div className='main-content h-100 dashboard-root-container'>
      <WritingMyContent individualPage={true} />
    </div>
  );
};

const NoMatchPage = () => {
  return <h3 className='px-5'>404 - Not found</h3>;
};

export { InfluenceWritingAssistant };
export default withAuthenticationRequired(InfluenceCrm, {
  onRedirecting: () => <Loading />,
  returnTo: `/login-success?returnUrl=${encodeURIComponent(
    `${window.location.pathname}${window.location.search}${window.location.hash}`
  )}`,
});
